export default {
  DATA_VIEWS: ({ dataViews }) => dataViews,
  CURRENT_DATA_VIEW: ({ currentDataView }) => currentDataView,
  DATA_VIEW_ITEMS: ({ dataViewItems }) => dataViewItems,
  EDIT_DATA_VIEW: ({ editDataView }) => editDataView,

  DATA_VIEW_LOADING: ({ dataViewsLoading }) => dataViewsLoading,
  DATA_VIEW_ITEMS_LOADING: ({ dataViewItemsLoading }) => dataViewItemsLoading,
  CURRENT_DATA_VIEW_LOADING: ({ currentDataViewLoading }) => currentDataViewLoading,
  EDIT_DATA_VIEW_LOADING: ({ editDataViewLoading }) => editDataViewLoading,
  CREATE_DATA_VIEW_LOADING: ({ createDataViewLoading }) => createDataViewLoading,
};
